<template>
	<v-container grid-list-md text-xs-center style="min-height: 93.4vh;">
		<v-layout row wrap>
			<v-toolbar extended>
				<v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">Reporte de Asistencia</v-toolbar-title>
				<v-flex v-show="$vuetify.breakpoint.xsOnly" xs12 class="titleSearch">
					<v-text-field
						class="mt-3"
						flat
						label="Reporte de Asistencia"
						prepend-inner-icon="search"
						solo-inverted
						clearable
					></v-text-field>
				</v-flex>
				<v-spacer></v-spacer>
				<template v-slot:extension>
					<v-layout row wrap>
						<v-flex
							xs12
							sm6
							xl4
							offset-xl4
							offset-sm3
							v-show="!$vuetify.breakpoint.xsOnly"
							class="titleSearch"
						>
							<v-text-field
								class="mx-3"
								flat
								label="Buscar"
								prepend-inner-icon="search"
								clearable
								solo-inverted
							></v-text-field>
						</v-flex>
						<v-flex mt-3 xs6 v-if="$vuetify.breakpoint.xsOnly">
							<v-menu
								v-model="menu.m1"
								:close-on-content-click="false"
								:nudge-right="40"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										label="Fecha"
										prepend-icon="event"
										readonly
										v-on="on"
										:value="momentFormatStartDate"
									></v-text-field>
								</template>
								<v-date-picker
									header-color="primary"
									color="secondary"
									v-model="date"
									@input="menu.m1 = false"
									locale="es-419"
								></v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex mt-3 xs6 v-if="$vuetify.breakpoint.xsOnly">
							<v-menu
								ref="time"
								v-model="menu.m2"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="filters.time"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								max-width="290px"
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										:value="filters.time"
										label="Hora de entrada"
										prepend-icon="access_time"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-time-picker
									v-if="menu.m2"
									v-model="filters.time"
									full-width
									@click:minute="$refs.time.save(filters.time)"
									color="secondary"
									header-color="primary"
									format="24hr"
								></v-time-picker>
							</v-menu>
						</v-flex>
					</v-layout>
				</template>
				<v-flex xs12 sm3 v-if="!$vuetify.breakpoint.xsOnly">
					<v-menu
						v-model="menu.m1"
						:close-on-content-click="false"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								label="Fecha"
								prepend-icon="event"
								readonly
								v-on="on"
								:value="momentFormatStartDate"
							></v-text-field>
						</template>
						<v-date-picker
							header-color="primary"
							color="secondary"
							v-model="date"
							@input="menu.m1 = false"
							locale="es-419"
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 sm3 v-if="!$vuetify.breakpoint.xsOnly">
					<v-menu
						ref="time"
						v-model="menu.m2"
						:close-on-content-click="false"
						:nudge-right="40"
						:return-value.sync="filters.time"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								:value="filters.time"
								label="Hora de entrada"
								prepend-icon="access_time"
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-time-picker
							v-if="menu.m2"
							v-model="filters.time"
							full-width
							@click:minute="$refs.time.save(filters.time)"
							color="secondary"
							header-color="primary"
							format="24hr"
						></v-time-picker>
					</v-menu>
				</v-flex>
			</v-toolbar>
			<v-container elevation-2 style="max-height: 75vh;" class="scrollDesign">
				<v-layout row wrap>
					<v-data-table
						ref="assistanceTable"
						:headers="headers"
						:items="items"
						:loading="working.loading"
						:search="filters"
						:custom-filter="customFilter"
						item-key="id"
						rows-per-page-text="Registros por página"
						no-data-text="No hay registros para mostrar"
					>
						<template v-slot:items="props">
							<td>
								<v-icon v-if="props.item.img == null || props.item.img == ''">account_circle</v-icon>
								<v-avatar size="30" v-else color="grey lighten-4">
									<img :src="'data:image/jpg;base64, ' + props.item.img" />
								</v-avatar>
							</td>
							<td>{{ props.item.firstName + ' ' + props.item.lastName }}</td>
							<td class="text-xs-right">{{ props.item.level.typeLevel }}</td>
							<td class="text-xs-right">{{ props.item.gg.grade + props.item.gg.group }}</td>
							<td class="text-xs-right">{{ props.item.gender }}</td>
							<td class="text-xs-right">{{ props.item.attendance }}</td>
							<td class="text-xs-right">{{ props.item.inHour }}</td>
							<td class="text-xs-right">{{ props.item.inHour }}</td>
						</template>
						<template
							v-slot:pageText="props"
						>{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
					</v-data-table>
				</v-layout>
			</v-container>
		</v-layout>
	</v-container>
</template>

<script>
	import moment from "moment";
	export default {
		mounted() {
			this.getReportsbyDate();
		},
		data: () => ({
			menu: {
				m1: false,
				m2: false
			},
			date: null,
			time: null,
			dateObject: null,
			working: {
				loading: false
			},
			items: [],

			filters: {
				search: "",
				time: ""
			},
			headers: [
				{
					text: "Foto",
					align: "center",
					value: "img"
				},
				{
					text: "Nombre",
					align: "left",
					value: "firstname",
					filterItems: []
				},
				{
					text: "Nivel",
					value: "level",
					filterItems: []
				},
				{ text: "Grado y Grupo", value: "gg", filterItems: [] },
				{ text: "Género", value: "gender", filterItems: [] },
				{ text: "Asistencia", value: "assistance", filterItems: [] },
				{ text: "Hora de entrada", value: "hin", filterItems: [] },
				{ text: "Hora de salida", value: "hout", filterItems: [] }
			]
		}),
		methods: {
			getReportsbyDate() {
				this.working.loading = true;
				let date = new Date();
				if (this.date == null) {
					this.date = date.toISOString().substr(0, 10);
				}
				this.$store
					.dispatch("reports/getAttendancebyDate", date.getTime())
					.then(response => {
						this.working.loading = false;
						this.items = response.data.entity;
					})
					.catch(error => {
						this.working.loading = false;
						console.log(error);
					});
			},
			customFilter(items, filters, filter, headers) {
				const cf = new this.$MultiFilters(items, filters, filter, headers);

				cf.registerFilter("search", function(searchWord, items) {
					if (searchWord == null || searchWord.trim() === "") return items;
					var transformMap = {
						a: "[aá]",
						e: "[eé]",
						i: "[ií]",
						o: "[oó]",
						u: "[uí]",
						A: "[AÁ]",
						E: "[EÉ]",
						I: "[IÍ]",
						O: "[OÓ]",
						U: "[UÚ]"
					};
					var search = searchWord ? searchWord : "";
					search = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
					for (var key in transformMap) {
						search = search.replace(key, transformMap[key]);
					}
					var matcher = new RegExp(search, "i");
					return items.filter(item => {
						return matcher.test(
							[
								item.firstName,
								item.lastName,
								item.level.typeLevel,
								item.gg.grade,
								item.gg.group
							].join()
						);
					}, searchWord);
				});

				// cf.registerFilter("hour", function(role, items) {
				// 	if (role.length == 0) return items;

				// 	return items.filter(item => {
				// 		for (var r in role) {
				// 			if (item.webRole.name.toLowerCase() === role[r].toLowerCase()) {
				// 				return true;
				// 			}
				// 		}
				// 		return false;
				// 	}, role);
				// });

				// Its time to run all created filters.
				// Will be executed in the order thay were defined.
				return cf.runFilters();
			}
		},
		computed: {
			momentFormatStartDate() {
				if (this.date != null) {
					return moment(this.date).format("DD/MM/YYYY");
				}
				return "";
			}
		}
	};
</script>

<style>
</style>
